import * as singleSpa from '@unicloud/single-spa';
import { checkBrowserVersion } from './utils/tools';

function loadingDom(status) {
  let el = document.getElementById('MLOAD');
  if (!el) {
      el = document.createElement('div');
      let img = document.createElement('img');
      img.src = 'static/img/loading.gif';
      img.style.position = 'absolute';
      img.style.top = '50%';
      img.style.left = '50%';
      img.style.width = '50px';

      el.appendChild(img);
      el.id = 'MLOAD';
      el.style.position = 'fixed';
      el.style.zIndex = '2000';
      el.style.top = '50px';
      el.style.left = '50px';
      el.style.width = '100%';
      el.style.height = '100%';
      el.style.backgroundColor = 'hsla(0,0%,100%,.9)';
      el.style.transition = 'opacity .3s';

      document.body.appendChild(el);
  }
  if (status) {
    el.style.display = 'block';
  } else {
    el.style.display = 'none';
  }
}

export function hashPrefix(prefix) {
  return function (location) {    
    let reg = /#\/(\w+)\/?/;
    reg.test(location.hash);
    return location.hash.startsWith(`#/${prefix}`) && RegExp.$1 === prefix;
  }
}

export function loadApp(microProject) {
  
  let { name, appURL, base, globalEventDistributor } = microProject;
  let customProps = { globalEventDistributor: globalEventDistributor };

  const loadFun = async () => {
    loadingDom(true);

    // let storeModule = {};
    
    // try {
    //   storeModule = storeURL ? await SystemJS.import(`${storeURL}`) : { storeInstance: null };
    // } catch (e) {
    //   console.log(`Could not load store of app ${name}.`, e);
    // }
  
    // if (storeModule.storeInstance && globalEventDistributor) {
    //   globalEventDistributor.registerStore(storeModule.storeInstance);
    // }

    return SystemJS.import(appURL).then((res) => {
      loadingDom(false);
      return res;
    }).catch((err) => {
      loadingDom(false);
      return err;
    })
  };

  checkBrowserVersion() && singleSpa.registerApplication(name, loadFun, base ? (() => true) : hashPrefix(name), customProps);
}